export default __webpack_public_path__ + "static/media/backgroundLabels.944cea8f.png";